import { GetterTree } from "vuex";
import { IRoleState } from "@/store/modules/role/state";
import { Role } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum RoleGetters {
  GET_ALL = "GET_ALL_ROLE",
  GET_CURRENT = "GET_CURRENT_ROLE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_ROLE",
}

export const getters: GetterTree<IRoleState, IRootState> = {
  [RoleGetters.GET_ALL](state): Role[] | null {
    return state.roles;
  },
  [RoleGetters.GET_CURRENT](state): Role | null {
    return state.role;
  },
  [RoleGetters.GET_DATA_PROVIDER](state): IDataProvider<Role> | null {
    return state.dataProvider;
  },
};
